import React from "react";
import PropTypes from "prop-types";
import Tab from "react/containers/layout/tabs/Tab";
import { connect } from "react-redux";
import { actionCreators } from "react/api/actions/dashboardAnalytics";

class AnalyticsDashboard extends Tab {
  constructor() {
    super();
    const analyticsURL = `${window.location.protocol}//${window.location.host}/analytics`;
    this.state = {
      iframeUrl: analyticsURL,
      returnTo: analyticsURL,
    };
  }

  static propTypes = {
    onClose: PropTypes.func,
    active: PropTypes.bool,
  };

  static tabName = "analytics.Dashboard";

  activeClassName = "is-active";

  helpOnClick = () => {
    const help = new Monet.UI.Help(
      "Analytics",
      Monet.I18n.getResourcesByKey("topMenu.analytics")
    );
    help.logIn();
  };

  updateIframeUrl = (url) => {
    const iframe = this.refs.iframe;
    if (iframe) {
      iframe.src = url;
    }
  };

  renderServiceUnavailable = () => {
    const iconPath = require("static/images/serviceUnavailable.svg");
    const titleLabel = Monet.I18n.getResourcesByKey(
      "analytics.serviceUnavailableTitle"
    );
    const messageLabel = Monet.I18n.getResourcesByKey(
      "analytics.serviceUnavailableMessage"
    );
    return (
      <div className="analyticsUnavailable">
        <div>
          <img className="analyticsUnavailableIcon" src={iconPath}></img>
          <div className="analyticsUnavailableTitle">{titleLabel}</div>
          <div className="analyticsUnavailableMessage">{messageLabel}</div>
        </div>
      </div>
    );
  };

  componentWillMount() {
    const { checkAnalyticsHealthAction, refreshToken } = this.props;
    checkAnalyticsHealthAction();
    refreshToken();
  }

  render() {
    const { className, isServiceUp, token } = this.props;
    const access_token = [...token.entries()].at(-1)[1];
    const { protocol, host } = window.location;

    const featureState = Monet.Session.ApplicationLoad.featureStates.find(obj => obj.name==="GM_ANALYTICS_MULTITENANT");
    const isMultiTenant = featureState?.enabled;

    let analyticsEndpoint = isMultiTenant ? 'analytics-service' : 'analytics';

    const src = `${protocol}//${host}/${analyticsEndpoint}`;
    const mainSrc = (isMultiTenant && !!access_token.access_token) ? `${protocol}//${host}/${analyticsEndpoint}/auth/sso?jwt=${access_token.access_token}&return_to=/${analyticsEndpoint}/browse` : src;
    const email = this.props.email;
    const emailNotFoundMessage = Monet.I18n.getResourcesByKey(
      "analytics.emailNotFound"
    );

    const labelHome = Monet.I18n.getResourcesByKey("analytics.home");
    const labelPulse = Monet.I18n.getResourcesByKey("analytics.pulse");
    const labelAskQuestion = Monet.I18n.getResourcesByKey(
      "analytics.askQuestion"
    );

    return (
      <div
        id="dashboardAnalytics"
        className={`${className} ${!isServiceUp ? "serviceUnavailable" : ""}`}
      >
        {!email ? (
          <div className="alert alert-error"> {emailNotFoundMessage} </div>
        ) : (
          ""
        )}
        {email && (
          <div className="analytics-container">
            <div className="navigation-bar">
              <div className="left-buttons">
                <button
                  className="navigation-button-secondary"
                  onClick={() => {
                    this.updateIframeUrl(src);
                  }}
                >
                  <i className="fa fa-home"></i> {labelHome}
                </button>
              </div>
              <div className="right-buttons">
                <button
                  className="navigation-button"
                  onClick={() => {
                    this.updateIframeUrl(`${src}/question/new`);
                  }}
                >
                  <i className="fa fa-plus"></i> {labelAskQuestion}
                </button>
                <button
                  className="navigation-button"
                  disabled
                  title={Monet.I18n.getResourcesByKey("analytics.button.pulse")}
                  onClick={() => {
                    this.updateIframeUrl(`${src}/pulse/create`);
                  }}
                >
                  <i className="fa fa-bolt"></i> {labelPulse}
                </button>
                <div className="MonetUIHelp MonetUIHelpAnalytics">
                  <a
                    className="MonetUIHelpLink"
                    onClick={() => this.helpOnClick()}
                  />
                </div>
              </div>
            </div>
            {isServiceUp !== null &&
              (isServiceUp ? (
                <iframe
                  title="GM-Analytics"
                  src={mainSrc}
                  ref="iframe"
                  sandbox="allow-scripts allow-forms allow-same-origin allow-downloads allow-modals allow-presentation"
                />
              ) : (
                this.renderServiceUnavailable()
              ))}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ user, dashboardAnalytics }) => ({
  email: user.get("email"),
  isServiceUp: dashboardAnalytics.get("isServiceUp"),
  token: dashboardAnalytics.get("tokens"),
});

const mapDispatchToProps = {
  checkAnalyticsHealthAction: actionCreators.checkAnalyticsHealth,
  refreshToken: actionCreators.refreshAnalyticsToken,
  analyticsEndpoint: actionCreators.analyticsEndpoint
};

export default connect(mapStateToProps, mapDispatchToProps)(AnalyticsDashboard);
